module.exports = __webpack_public_path__ + "img/27.cdf450f3.jpg";